export default "__VITE_ASSET__D_CmEkB$__"